export interface IImageProxyOptions {
	url: string;
	size?: string;
	lazy?: boolean;
	as?: string;
	placeholder?: string;
	quality?: string;
	resize?: {
		width: string;
		height: string;
	};
	format?: string;
	alt?: string;
}

export const defaultPreset: IImageProxyOptions = {
	url: '',
	size: undefined,
	lazy: true,
	as: '',
	placeholder: '',
	quality: '70',
	resize: undefined,
	format: 'webp',
	alt: ''
};
